<tabs-inner-wrap>
  <assignment-information></assignment-information>
</tabs-inner-wrap>
